import { AccessCase, Prisma } from '@prisma/client';
import { useQuery } from '@tanstack/react-query';

import { Axios } from '@app/web-components';

const ACCESS_CASE_ALL_QUERY_KEY = 'ACCESS_CASE_ALL_QUERY_KEY';

export const accessCaseKeys = {
  all: [ACCESS_CASE_ALL_QUERY_KEY] as const,
  lists: () => [...accessCaseKeys.all, 'list'] as const,
  list: (filters: object) => [...accessCaseKeys.lists(), filters] as const,
  details: () => [...accessCaseKeys.all, 'detail'] as const,
  detail: (id: number) => [...accessCaseKeys.details(), id] as const,
};

export const useAccessCaseFind = <T extends Partial<AccessCase>>({
  enabled,
  ...params
}: Prisma.AccessCaseFindManyArgs & { enabled?: boolean }) => {
  const axios = Axios.useAxiosApi();

  return useQuery<T[]>({
    queryKey: accessCaseKeys.list(params),
    queryFn: async () => {
      const { data } = await axios.post('/access-cases/find', params);
      return data;
    },
    enabled,
  });
};

export const useAccessCaseFindUnique = <T>({
  enabled,
  ...params
}: Prisma.AccessCaseFindUniqueArgs & { enabled?: boolean }) => {
  const axios = Axios.useAxiosApi();

  return useQuery<T>({
    queryKey: params?.where?.id ? accessCaseKeys.detail(params.where.id) : accessCaseKeys.list(params),
    queryFn: async () => {
      const { data } = await axios.post('/access-cases/find-unique', params);
      return data;
    },
    enabled,
  });
};
